import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

const ImageWithFallback = ({ src, alt, className, style, ...props }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <div className="position-relative" style={style}>
      {isLoading && (
        <div 
          className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: '#f8f9fa' }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      {hasError ? (
        <div 
          className={`d-flex align-items-center justify-content-center ${className}`}
          style={{ 
            backgroundColor: '#f8f9fa',
            color: '#6c757d',
            height: '100%',
            minHeight: '200px',
            ...style
          }}
        >
          <div className="text-center">
            <i className="fas fa-image mb-2" style={{ fontSize: '2rem' }}></i>
            <p className="mb-0">Image not available</p>
          </div>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          className={className}
          style={{ ...style, display: isLoading ? 'none' : 'block' }}
          onLoad={handleLoad}
          onError={handleError}
          {...props}
        />
      )}
    </div>
  );
};

export default ImageWithFallback; 